/**
 * /support/ — content.
 *
 * Copy is carried over verbatim from the Tilda export
 * (src/data/tilda/24566159.json); only the layout was rebuilt for the Dashly
 * design system. Images were pulled off the Tilda CDN into static/support/ and
 * re-encoded, so the page no longer depends on Tilda in any way.
 */

export const heroData = {
  title: "Decrease your response time and retain customers",
  subtitle:
    "Use Dashly tools to improve Customer Support performance. Be in context of every inquiry and enjoy high ratings of your work!",
  cta: "Start free trial",
  image: "/support/hero.avif",
  imageAlt: "Dashly support inbox with a customer conversation",
};

/** Standalone heading block that sat between the hero and the feature list. */
export const featuresHeading = "Customer support software for growing support teams";

export interface Feature {
  title: string;
  points: string[];
  image: string;
  imageAlt: string;
  /** Image on the left instead of the right. */
  reversed?: boolean;
}

export const featuresData: Feature[] = [
  {
    title: "Live chat support that moves conversations off the phone",
    points: [
      "Give your clients a convenient way to reach out to you",
      "Use the history of your communication to create a better experience and solve problems faster",
    ],
    image: "/support/live-chat.avif",
    imageAlt: "Live chat conversation with a returning customer",
  },
  {
    title: "Shared inbox and saved replies for faster responses",
    points: [
      "Route conversations to the right teams based on rules or a chatbot workflow",
      "Hand conversation to other agents of your team",
      "Create your own knowledge base with answers to frequently asked questions",
      "Use saved replies to answer quicker",
    ],
    image: "/support/routing.webp",
    imageAlt: "Conversation being routed to the right team by a chatbot",
    reversed: true,
  },
  {
    title: "Proactive customer support powered by customer data",
    points: [
      "Use data to understand the frictions in your customer journey",
      "Create targeted pop-ups, emails, chatbot to help customer right when they need it",
    ],
    image: "/support/customer-data.avif",
    imageAlt: "Customer profile with properties and event history",
  },
  {
    title: "Conversation analytics for support quality and team workload",
    points: [
      "Get customers' feedback and evaluation on the quality of their interaction with the support team. Analyze poor-rated conversations.",
      "Track the workload of your team, identify peak hours, and plan shifts accordingly",
    ],
    image: "/support/analytics.avif",
    imageAlt: "Support team performance report",
    reversed: true,
  },
];

export const seatsData = {
  title: "Unlimited seats for your whole support team",
  text: "Unlimited number of seats for everyone in your team to get on board of customer communications",
  cta: "Start 7 day free trial",
  image: "/support/team.avif",
  imageAlt: "Support team members",
};

export interface Step {
  title: string;
  text: string;
  image: string;
  link?: { label: string; href: string };
}

export const stepsData = {
  title:
    "5 steps to reduce your support team\u2019s workload",
  cta: "Start 7 day free trial",
  steps: [
    {
      title: "Set up live chat on your website",
      text: "add team members and appoint the ones responsible for conversations set up the working hours create saved replies",
      image: "/support/step-live-chat.avif",
      link: { label: "Read more", href: "/live-chat/" },
    },
    {
      title: "Create a knowledge base for self-service",
      text: "put answers to frequently asked questions let visitors find them on their own send the links to the knowledge base for a quicker answer",
      image: "/support/step-knowledge-base.avif",
      link: { label: "Read more", href: "/knowledgebase/" },
    },
    {
      title: "Launch a customer support chatbot",
      text: "clarify questions, route the conversation to the right agent and decrease the response time",
      image: "/support/step-chatbot.avif",
      link: { label: "Read more", href: "/custom-chatbot/" },
    },
    {
      title: "Automate feedback and notifications",
      text: "feedback collection, payment notifications, abandoned cart reminders, etc.",
      image: "/support/step-automation.avif",
      link: { label: "Read more", href: "/ready-made-campaigns/" },
    },
    {
      title: "Support customers from the Dashly mobile app",
      text:
        "Agents can communicate with customers via Dashly mobile application and send knowledge base articles straight from the app on the go Download Dashly mobile app and stay in touch with your customers from anywhere in the world",
      image: "/support/step-mobile-app.avif",
    },
  ] as Step[],
  apps: [
    {
      href: "https://itunes.apple.com/ru/app/carrrot/id1417779506?l=en&mt=8",
      image: "/support/badge-appstore.avif",
      alt: "Download Dashly on the App Store",
    },
    {
      href: "https://play.google.com/store/apps/details?id=io.carrrot.CarrrotApp",
      image: "/support/badge-googleplay.avif",
      alt: "Get Dashly on Google Play",
    },
  ],
};

export const finalCtaData = {
  title: "Reduce response time with customer service software",
  lines: ["7 days of free trial.", "No credit card required"],
  cta: "START FOR FREE",
  image: "/support/final-cta.avif",
};

export const REGISTER_URL = "/panel/unauthorized/register";
